import { css, cx } from '@emotion/css';
import { VenueUrls } from 'Common/VenueUrls';
import { locateSubDocument } from 'Common/ViewUtils';
import { tabStyle,repeaterPaneStyle } from 'Shared/backend/contact/ContactPage';
import { IconColour } from 'Shared/backend/IconColour';
import { LinkOpen } from 'Shared/backend/icons/LinkOpen';
import { inlineOpenLinkStyle } from 'Shared/backend/Theme';
import { palette, theme } from 'Shared/backend/ThemeProvider';
import { ImageUpload } from 'Shared/forms/ImageUpload';
import { Checkbox, Html, MultiSelect, Text } from 'Shared/forms/Inputs';
import { addItemAndOpen, StoreRepeater } from 'Shared/forms/StoreRepeater';
import { LabelOnLeftWrap, Wrap } from 'Shared/forms/Wrap';
import { usePage } from 'Shared/frontend/PageProvider';
import { Show } from 'solid-js';
import { reconcile } from 'solid-js/store';


const imageUploadStyle = () => css({
	img: {
		maxHeight: 200
	}
});

const activeStyle = () => css({
	color: palette().active
});


export function AboutTab(props)
{
	let paragraphNode;

	const title = i => {
		let ret = i.title;
		if (i.display)
			ret += ` (On ${i.display} page)`;
		return ret;
	};

	return (
		<div class={tabStyle()}>
			<h3 class={css(theme().section.blueHeading)}>About your venue</h3>

			<StoreRepeater ref={paragraphNode} {...props} page={props.page} field='aboutList' renderTitle={i => title(i)}>
				{(item,index) => <Paragraph {...props} {...item} location={['aboutList',index]} index={index} />}
			</StoreRepeater>

			<button class={css(theme().button,{alignSelf:'start'})}
				onClick={() => addItemAndOpen({...props,permission:'edit',field:'aboutList'},paragraphNode,{})}
			>
				<i class='fas fa-plus'/> Add paragraph
			</button>

			<ImageUploads {...props} />
		</div>
	);
}

function Paragraph(props)
{
	const page = usePage();
	const urls = new VenueUrls(page.build,page.site.key);

	const displayOptions = {
		home:'Home',
		contact:'Contact', 
		reservation:'Reservation',
		hire:'Hire Enquiry',
		members:'Club',
		menu:'Menu',
		events:'Events',
		staff:'Staff',
		other: 'Other'
	};

//XXX options slighlty different from those in GeneralTab. Any reason why?
	const htmlOptions = {
		height: 200,
		menubar: false,
		plugins: ['link'],
		toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright alignjustify | outdent indent | link ',
		statusbar: true,
		resize: true
	};

	return (
		<div class={repeaterPaneStyle('1.2em')}>
			<Wrap label='Display on Page/s'>
				<MultiSelect {...props} field='display' options={displayOptions} />
			</Wrap>

			<Show when={props.display?.other}>
				<Wrap label='Experimental - not mapped to any specific page'>
					<Text {...props} field='displayOn' />
				</Wrap>
			</Show>

			<a class={cx(inlineOpenLinkStyle(),activeStyle())} href={props.display == 'home' ? '/' : '/'+props.display} target='_blank'>
				View on {props.display} page <LinkOpen class={css(theme().linkIcon)} fill={IconColour.active} />
			</a>

			<Wrap label='Title'>
				<Text {...props} field='title' />
			</Wrap>

			<LabelOnLeftWrap label='Hide title on webpage'
				notes='Tip: you may want to hide if embedding a form that has a Title'
			>
				<Checkbox {...props} field='hideTitle' />
			</LabelOnLeftWrap>

			<Wrap label='Description'>
				<Html {...props} field='description' options={htmlOptions} urls={urls} />
			</Wrap>

			<Wrap label='Embed iframe url'>
				<Text {...props} field='embedUrl' />
			</Wrap>

			<Wrap label='Embed Height (pixel number only)'
				notes='Tip: check how it looks on mobile or a narrow screen, and if a scrollbar appears increase the height'
			>
				<Text {...props} field='embedHeight' />
			</Wrap>

			<LabelOnLeftWrap label='50% width on widescreens'>
				<Checkbox {...props} field='halfWidth' />
			</LabelOnLeftWrap>

			{/* Currently hidden beacuse not used on townie and CJ hasn't styled frontend yet.but its in database as its inevitable we will need it.
				<x-field>
					{{ imageUpload.label('Optional image (landscape ratio 3:2)') }}
					{{ imageUpload.impl('aboutList',location,'photo','about','photo',current.photo,true,{ratio:1.5,minWidth:800}) }}
				</x-field>
			*/}
		</div>
	);
}

function ImageUploads(props)
{
	const page = usePage();
	const urls = new VenueUrls(page.build,page.site.key);

	const setLogo = value => props.setStore(...props.location,'logo',reconcile(value));
	const logo = () => locateSubDocument(props.store,[...props.location,'logo']);

	const setPhoto = value => props.setStore(...props.location,'photo',reconcile(value));
	const photo = () => locateSubDocument(props.store,[...props.location,'photo']);

	const setLogoLandscape = value => props.setStore(...props.location,'logoLandscape',reconcile(value));
	const logoLandscape = () => locateSubDocument(props.store,[...props.location,'logoLandscape']);

// TODO cj add other image dimension options for logo currently just square 
	return (
		<div>
			<Wrap label='Add venue logo'>
				<div class={imageUploadStyle()}>
					<ImageUpload 
						docId={props.docId}
						location={[...props.location,'logo']}
						image={logo()} 
						setImage={setLogo}
						urls={urls}
						dimensions='square'
						permission='logo'
						fallbackUrl='defaults/profile1x1.png'
						previewSize='full'
						page={page}
					/>
				</div>
			</Wrap>

			<Wrap label='Add venue photo'>
				<div class={imageUploadStyle()}>
					<ImageUpload 
						docId={props.docId}
						location={[...props.location,'photo']}
						image={photo()} 
						setImage={setPhoto}
						urls={urls}
						dimensions='landscape'
						permission='photo'
						fallbackUrl='defaults/profile3x2.png'
						previewSize='full'
						page={page}
					/>
				</div>
			</Wrap>

			<Wrap label='OG Image'>
				<div class={imageUploadStyle()}>
					<ImageUpload 
						docId={props.docId}
						location={[...props.location,'logoLandscape']}
						image={logoLandscape()} 
						setImage={setLogoLandscape}
						urls={urls}
						dimensions='landscape'
						permission='logoLandscape'
						fallbackUrl='defaults/profile3x2.png'
						previewSize='full'
						page={page}
					/>
				</div>
			</Wrap>
		</div>
	);
}
